import React, { forwardRef } from 'react';

import { DialogoProduto2 } from '../../Components';
import { api, getUserId } from '../../services';

const Container = forwardRef(
  ({ handleClose, conferencia_burra_propriedade_produto_id }, ref) => {
    async function handleCloseLocal(id) {
      const response = await api.post(
        '/conferencia_propriedade_produtos_itens',
        {
          conferencia_burra_propriedade_produto_id,
          produto_id: id,
          user_id: getUserId(),
        },
      );

      handleClose();
    }

    return (
      <DialogoProduto2
        ref={ref}
        handleClose={handleCloseLocal}
        isImprimir={false}
      />
    );
  },
);

export default Container;
